import { createContext } from 'react'
import type { SuspensionReason } from '@/graphql.types'

export const CompanySuspensionContext = createContext<{
  isSuspended: boolean
  suspensionReason: SuspensionReason | null
}>({
  isSuspended: false,
  suspensionReason: null,
})
